const { createApp } = Vue

const app = createApp({
  data() {
    return {
      tabs: [],
      articles: [],
      ready: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.tabs = document.querySelectorAll('.hammesHomepage #intro .tabs .tab')
      this.articles = document.querySelectorAll(
        '.hammesHomepage #intro .articles article'
      )

      this.mountTabs()
      this.ready = true
    },
    mountTabs() {
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          this.tabs.forEach((tab) => {
            tab.classList.remove('active')
          })

          tab.classList.add('active')

          this.articles.forEach((tabContent) => {
            tabContent.classList.remove('active')
          })

          this.articles[i].classList.add('active')
        })
      })
    },
  },
})

app.config.compilerOptions = {
  whitespace: 'condense',
}

app.mount('.hammesHomepage #intro')
